import { makeStyles } from "@material-ui/core"

export const vendorDetachedTemplateStyle = makeStyles((theme) => ({
    container: {
        marginTop: '1em',
        marginBottom: '1em',
        border: '1px solid #ddd',
        borderRadius: '5px',
        padding: '1em',
    },
    sectionTitle: {
        fontWeight: 'bold',
        marginBottom: '1em',
        color: theme.palette.primary.dark,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1em',
    },
    fieldLabel: {
        fontWeight: 'bold',
        marginBottom: '0.25em',
    },
    fieldValue: {
        marginBottom: '1em',
    },
    subjectInput: {
        width: '100%',
        marginBottom: '1em',
    },
    bodyWrapper: {
        marginBottom: '1em',
    },
    actions: {
        display: 'flex',
        gap: '0.5em',
        justifyContent: 'flex-end',
        marginTop: '0.5em',
    },
}));
